import '@babel/polyfill';
import Vue from 'vue';
import './plugins/bootstrap-vue';
import './plugins/axios';
import App from './App.vue';
import router from './router';
import store from './store';
import VueLodash from 'vue-lodash'


Vue.use(VueLodash)
 
Vue.config.productionTip = false;
import $ from 'jquery'

import VueProgressBar from 'vue-progressbar'
const options = {
  color: '#6d8d23',
  failedColor: '#874b4b',
  thickness: '2px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  autoFinish: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, options)

Vue.use(require('vue-moment'));

import helpers from './helpers';
const helpersPlugin = {
  install () {
      Vue.helpers = helpers
      Vue.prototype.$helpers = helpers
  }
}

Vue.use(helpersPlugin)

new Vue({
  store: store,
  router: router,
  render: h => h(App)
}).$mount('#app');
